import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { HighlightSyntax, _AbcTreeNode } from '@barthauer/abc/ui-components';
import { AbcQueriesEditorService } from '../../../abc-queries-editor.service';
import { ResultsService } from '../../../services/result.service';
import { Property } from '../../../viewModels/abc-queries-editor.viewModel';

@Component({
  selector: 'abc-opath-queries-editor-results-query-xml',
  templateUrl: './results-query-xml.component.html',
  styleUrls: ['./results-query-xml.component.scss'],
})
export class ResultsQueryXmlComponent {
  @ViewChild('code') code: ElementRef;
  private queries: _AbcTreeNode<Property>;
  private xmlResult: string = '';
  private highlightSyntax: HighlightSyntax = new HighlightSyntax(this.renderer);

  constructor(
    private resultsService: ResultsService,
    private abcQueriesEditorService: AbcQueriesEditorService,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.refreshQueriesData();
  }

  public refreshQueriesData() {
    this.queries = this.abcQueriesEditorService.queries;
    if (this.queries) {
      this.xmlResult = this.resultsService.createXmlObjectQueries(
        this.queries,
        this.abcQueriesEditorService.objectSpaceName,
        this.abcQueriesEditorService.rootElementName
      );
    } else {
      this.xmlResult = `<ObjectQueryDocument objectSpace="${this.abcQueriesEditorService.objectSpaceName}">\n  <ObjectQueries>\n  </ObjectQueries>\n</ObjectQueryDocument>\n`;
    }

    this.code.nativeElement.innerHTML = this.highlightSyntax.highlight('xml', this.xmlResult).value;
  }
}
